export const FREE_KUNDLI_TRANSLATIONS: Record<string, any> = {
    'English': {
        // Planet Names (Full)
        planetNames: {
            Sun: 'Sun',
            Moon: 'Moon',
            Mars: 'Mars',
            Mercury: 'Mercury',
            Jupiter: 'Jupiter',
            Venus: 'Venus',
            Saturn: 'Saturn',
            Rahu: 'North Node (Rahu)',
            Ketu: 'South Node (Ketu)',
            Ascendant: 'Ascendant'
        },
        // Planet Names (Short - for Lagna chart)
        planetAbbr: {
            Sun: 'Su',
            Moon: 'Mo',
            Mars: 'Ma',
            Mercury: 'Me',
            Jupiter: 'Ju',
            Venus: 'Ve',
            Saturn: 'Sa',
            Rahu: 'Ra',
            Ketu: 'Ke',
            Ascendant: 'As'
        },
        // Divisional Chart Names
        chartNames: {
            D1: 'Lagna',
            D2: 'Hora',
            D3: 'Drekkana',
            D4: 'Chaturthamsa',
            D7: 'Saptamsa',
            D9: 'Navamsa',
            D10: 'Dasamsa',
            D12: 'Dwadasamsa',
            D16: 'Shodasamsa',
            D20: 'Vimsamsa',
            D24: 'Chaturvimsamsa',
            D27: 'Saptavimsamsa',
            D30: 'Trimsamsa',
            D40: 'Khavedamsa',
            D45: 'Akshavedamsa',
            D60: 'Shastiamsa'
        },
        // Mahadasha suffix
        mahadashaSuffix: 'Mahadasha',
        heroTitle: "Free Kundli Generation",
        heroSubtitle: "Get your detailed birth chart analysis instantly",
        overview: "Overview",
        kundli: "Kundli",
        charts: "Charts",
        planets: "Planets",
        dasha: "Dasha",
        doshas: "Doshas",
        predictions: "Predictions",
        newKundli: "New Kundli",
        newChart: "New Chart",
        wantGuidance: "Want Personalized Guidance?",
        chatWithAI: "Chat with AI Astrologer",
        guidanceDesc: "Get detailed birth chart analysis and personalized daily predictions with our AI astrologer Maharishi Bhrigu.",

        // Kundli Tab
        lagnaChart: "Lagna Chart",
        lagnaChartDesc: "Birth chart showing planetary positions at the time of birth.",
        navamsaChart: "Navamsa Chart",
        navamsaChartDesc: "D9 divisional chart for marriage, fortune, and spiritual growth.",

        // Charts Tab
        allCharts: "All Divisional Charts",
        allChartsDesc: "Complete collection of Varga charts (D1 to D60) for detailed analysis.",
        noData: "No data available",

        // Report Tab
        report: "Report",
        yogas: "Yogas",
        doshasLabel: "Doshas",
        gemstones: "Gemstones",
        gemstonesShort: "Gems",
        rudraksha: "Rudraksha",
        rudrakshaShort: "Rudra",
        totalYogas: "Total Yogas Found",
        totalDoshas: "Total Doshas Found",
        benefits: "Benefits",
        strength: "Strength",
        mainYogas: "Main Yogas",
        mainYogasDesc: "Key planetary combinations in your chart",
        gajaKesariYoga: "Gaja Kesari Yoga",
        budhaAdityaYoga: "Budha-Aditya Yoga",
        chandraMangalaYoga: "Chandra-Mangala Yoga",
        dharmaKarmaYoga: "Dharma-Karmadhipati Yoga",
        panchaMahapurusha: "Pancha Mahapurusha Yogas",
        panchaMahapurushaDesc: "Five great personality yogas",
        doshaAnalysis: "Dosha Analysis",
        doshaAnalysisDesc: "Planetary afflictions in your chart",
        grahanDosha: "Grahan Dosha",
        grahanDesc: "Eclipse combination affecting mental peace and clarity.",
        pitraDosha: "Pitra Dosha",
        pitraDesc: "Ancestral karma affecting family lineage and blessings.",
        gemstoneRecommendations: "Gemstone Recommendations",
        gemstoneDesc: "Based on your ascendant and planetary positions",
        lifeStone: "Life Stone",
        luckyStone: "Lucky Stone",
        fortuneStone: "Fortune Stone",
        rulingPlanet: "Ruling Planet",
        note: "Note",
        gemstoneNote: "Please consult with a qualified astrologer before wearing any gemstone. The effects vary based on individual charts and current planetary periods.",
        rudrakshRecommendations: "Rudraksha Recommendations",
        rudrakshDesc: "Sacred beads for spiritual and planetary balance",
        lifeRudraksha: "Life Rudraksha",
        fortuneRudraksha: "Fortune Rudraksha",
        rudrakshNote: "Rudraksha beads should be properly energized and worn after consulting with a qualified astrologer. Regular meditation and chanting enhance their spiritual benefits.",


        // Overview Tab
        birthDetails: "Birth Details",
        birthDetailsDesc: "Essential information about your birth time, date, and location.",
        name: "Name",
        gender: "Gender",
        dateOfBirth: "Date of Birth",
        timeOfBirth: "Time of Birth",
        lagnaAsc: "Lagna (Asc)",
        moonSign: "Moon Sign",
        location: "Location",
        avakhadaChakra: "Avakhada Chakra",
        avakhadaDesc: "Moon sign characteristics and astrological attributes for compatibility.",
        rashi: "Rashi",
        rashiLord: "Rashi Lord",
        varna: "Varna",
        vashya: "Vashya",
        yoni: "Yoni",
        gana: "Gana",
        nadi: "Nadi",
        tatva: "Tatva",
        alphabet: "Alphabet",
        paya: "Paya",
        birthPanchang: "Birth Panchang",
        panchangDesc: "Auspicious elements and cosmic energies at the time of your birth.",
        vaara: "Vaara (Day)",
        tithi: "Tithi",
        nakshatra: "Nakshatra",
        yoga: "Yoga",
        karana: "Karana",
        chartSuffix: "Chart",
        chartDesc: "Visual representation of planetary placements.",

        // Planets Tab
        planetaryPositions: "Planetary Positions",
        planetsDesc: "Detailed angular positions and dignities of planets at the time of your birth.",
        planet: "Planet",
        sign: "Sign",
        degree: "Degree",
        house: "House",
        pada: "Pada",
        dignity: "Dignity",
        nature: "Nature",
        ascendant: "Ascendant",
        malefic: "Malefic",
        benefic: "Benefic",

        // Dasha Tab
        vimshottariDasha: "Vimshottari Dasha",
        dashaDesc: "Planetary time periods that influence different phases of your life.",
        backTo: "Back to",
        mahadasha: "Mahadasha",
        antardasha: "Antardasha",
        pratyantardasha: "Pratyantardasha",
        currPeriod: "Current Period",
        starts: "Starts",
        ends: "Ends",
        duration: "Duration",
        years: "Years",

        // Dosha Tab
        manglikDosha: "Manglik Dosha",
        manglikDesc: "Mars placement affecting marital harmony and relationships.",
        present: "Present",
        absent: "Absent",
        severity: "Severity",
        kalsarpaAnalysis: "Kalsarpa Analysis",
        kalsarpaDesc: "North Node (Rahu)-South Node (Ketu) axis influence on life challenges and spiritual growth.",
        type: "Type",
        noKalsarpa: "No Kaal Sarp Dosha",
        sadesatiAnalysis: "Shani Sadesati Analysis",
        sadesatiDesc: "Saturn's seven-and-a-half year transit period and its effects.",
        inSadesati: "Currently in Sadesati Period",
        notInSadesati: "Not in Sadesati Period",
        currentlyActive: "Currently Active",
        currentPhase: "Current Phase",
        nextStartsOn: "Next Starts On",
        severityLevel: "Severity Level",
        timelineSadesati: "Timeline of Sadesati Periods",
        startDate: "Start Date",
        endDate: "End Date",
        saturnSign: "Saturn sign",
        saturnIn: "Saturn in",
        phase: "Phase",
        status: "Status",
        active: "Active",
        upcoming: "Upcoming",
        completed: "Completed",
        yes: "Yes",
        no: "No",
        none: "None",

        // Predictions Tab
        predictionsGenerating: "Detailed predictions are being generated. Please wait or try generating the Kundli again.",
        faladeshTitle: "Faladesh - Life Predictions",
        faladeshDesc: "Comprehensive life insights based on your Ascendant Sign.",
        generalDesc: "General Description",
        personalityTraits: "Personality Traits",
        physicalAppearance: "Physical Appearance",
        healthInsights: "Health Insights",
        careerProspects: "Career Prospects",
        relationships: "Relationships",
        planetEffectsTitle: "Planetary Effects in D1 Chart",
        planetEffectsDesc: "How each planet influences your life based on its position in your birth chart.",
        mahaDashaTitle: "Maha Dasha Predictions",
        mahaDashaDesc: "Detailed forecasts for each major planetary period in your life.",

        // Hero Section
        freeKundliOnline: "Kundli Online",
        freeKundliDesc: "Get instant & accurate Janam Kundli. Enter your birth details to unlock personalized planetary positions and deep astrological insights.",

        // Kundli Form
        enterDetails: "ENTER DETAILS",
        createYour: "Create Your",
        kundliTitle: "Kundli",
        enterBirthDetails: "Enter your birth details to generate your detailed Janam Kundli.",
        fullName: "Full Name",
        fullNamePlaceholder: "Enter full name",
        birthLocation: "Birth Location",
        placeOfBirth: "Place of Birth",
        searchCity: "Search City",
        male: "Male",
        female: "Female",
        other: "Other",
        generating: "Generating...",
        readingStars: "Reading Stars...",
        generateKundli: "Generate Kundli",
        generateFreeKundli: "GENERATE FREE KUNDLI",
        reset: "Reset",
        clearForm: "Clear Form",

        // Saved Kundli List
        savedCharts: "Saved Charts",
        searchCharts: "Search charts...",
        loading: "Loading...",
        noSavedKundlisYet: "No saved kundlis yet",
        cloudSaved: "Cloud Saved",
        deleteFromCloud: "Delete from cloud",
        savedLocally: "Saved Locally",
        saveToCloud: "Save to cloud",
        removeLocal: "Remove local",
        login: "Login",
        toSyncKundlis: "to sync your kundlis to cloud and access from anywhere.",
        kundliRemoved: "Kundli removed",
        kundliDeletedCloud: "Kundli deleted from cloud",
        loginToSave: "Please login to save to cloud",
        kundliSavedCloud: "Kundli saved to cloud!",
        viewChart: "View Chart",
        delete: "Delete",
        openKundli: "Open Kundli",
        noChartsFound: "No charts found for",

        // PDF Download
        downloadPdf: "Download PDF",
        viewAndPrint: "View & Print",
        downloadKundli: "Download Your Kundli",
        downloadKundliDesc: "Get your complete birth chart analysis in PDF format",
        language: "Language",
        kundliReport: "Kundli Report",
        generatedBy: "Generated by BhriguGPT",
        generatedOn: "Generated on",
        pdfDownloading: "Preparing PDF...",
        pdfReady: "PDF ready for download!",
        pdfError: "Failed to generate PDF"
    },
    'Hindi': {
        // Planet Names (Full)
        planetNames: {
            Sun: 'सूर्य',
            Moon: 'चंद्र',
            Mars: 'मंगल',
            Mercury: 'बुध',
            Jupiter: 'बृहस्पति',
            Venus: 'शुक्र',
            Saturn: 'शनि',
            Rahu: 'राहु',
            Ketu: 'केतु',
            Ascendant: 'लग्न'
        },
        // Planet Names (Short - for Lagna chart)
        planetAbbr: {
            Sun: 'सू',
            Moon: 'चं',
            Mars: 'मं',
            Mercury: 'बु',
            Jupiter: 'गु',
            Venus: 'शु',
            Saturn: 'श',
            Rahu: 'रा',
            Ketu: 'के',
            Ascendant: 'ल'
        },
        // Divisional Chart Names
        chartNames: {
            D1: 'लग्न',
            D2: 'होरा',
            D3: 'द्रेक्काण',
            D4: 'चतुर्थांश',
            D7: 'सप्तांश',
            D9: 'नवांश',
            D10: 'दशमांश',
            D12: 'द्वादशांश',
            D16: 'षोडशांश',
            D20: 'विंशांश',
            D24: 'चतुर्विंशांश',
            D27: 'सप्तविंशांश',
            D30: 'त्रिंशांश',
            D40: 'खवेदांश',
            D45: 'अक्षवेदांश',
            D60: 'षष्ट्यंश'
        },
        // Mahadasha suffix
        mahadashaSuffix: 'महादशा',
        heroTitle: "निःशुल्क कुंडली",
        heroSubtitle: "अपनी विस्तृत जन्म कुंडली विश्लेषण तुरंत प्राप्त करें",
        overview: "अवलोकन",
        kundli: "कुंडली",
        charts: "चार्ट्स",
        planets: "ग्रह",
        dasha: "दशा",
        doshas: "दोष",
        predictions: "भविष्यवाणी",
        newKundli: "नई कुंडली",
        newChart: "नई चार्ट",
        wantGuidance: "क्या आप व्यक्तिगत मार्गदर्शन चाहते हैं?",
        chatWithAI: "AI ज्योतिषी से चैट करें",
        guidanceDesc: "हमारे AI ज्योतिषी महर्षि भृगु के साथ विस्तृत जन्म कुंडली विश्लेषण और व्यक्तिगत दैनिक भविष्यवाणियां प्राप्त करें।",

        // Kundli Tab
        lagnaChart: "लग्न कुंडली",
        lagnaChartDesc: "जन्म के समय ग्रहों की स्थिति दर्शाने वाली जन्म कुंडली।",
        navamsaChart: "नवांश कुंडली",
        navamsaChartDesc: "विवाह, भाग्य और आध्यात्मिक विकास के लिए D9 वर्ग चार्ट।",

        // Charts Tab
        allCharts: "सभी वर्ग कुंडली",
        allChartsDesc: "विस्तृत विश्लेषण के लिए वर्ग चार्ट (D1 से D60) का पूर्ण संग्रह।",
        noData: "कोई डेटा उपलब्ध नहीं",

        // Report Tab
        report: "रिपोर्ट",
        yogas: "योग",
        doshasLabel: "दोष",
        gemstones: "रत्न",
        gemstonesShort: "रत्न",
        rudraksha: "रुद्राक्ष",
        rudrakshaShort: "रुद्राक्ष",
        totalYogas: "कुल योग पाए गए",
        totalDoshas: "कुल दोष पाए गए",
        benefits: "लाभ",
        strength: "शक्ति",
        mainYogas: "मुख्य योग",
        mainYogasDesc: "आपकी कुंडली में महत्वपूर्ण ग्रहीय संयोजन",
        gajaKesariYoga: "गज केसरी योग",
        budhaAdityaYoga: "बुधादित्य योग",
        chandraMangalaYoga: "चंद्र मंगल योग",
        dharmaKarmaYoga: "धर्म-कर्माधिपति योग",
        panchaMahapurusha: "पंच महापुरुष योग",
        panchaMahapurushaDesc: "पांच महान व्यक्तित्व योग",
        doshaAnalysis: "दोष विश्लेषण",
        doshaAnalysisDesc: "आपकी कुंडली में ग्रहीय पीड़ाएं",
        grahanDosha: "ग्रहण दोष",
        grahanDesc: "मानसिक शांति और स्पष्टता को प्रभावित करने वाला ग्रहण संयोजन।",
        pitraDosha: "पितृ दोष",
        pitraDesc: "पारिवारिक वंश और आशीर्वाद को प्रभावित करने वाला पूर्वज कर्म।",
        gemstoneRecommendations: "रत्न सुझाव",
        gemstoneDesc: "आपके लग्न और ग्रह स्थितियों के आधार पर",
        lifeStone: "जीवन रत्न",
        luckyStone: "भाग्यशाली रत्न",
        fortuneStone: "भाग्य रत्न",
        rulingPlanet: "स्वामी ग्रह",
        note: "नोट",
        gemstoneNote: "कोई भी रत्न धारण करने से पहले किसी योग्य ज्योतिषी से परामर्श करें। प्रभाव व्यक्तिगत कुंडली और वर्तमान ग्रह अवधि के आधार पर भिन्न होते हैं।",
        rudrakshRecommendations: "रुद्राक्ष सुझाव",
        rudrakshDesc: "आध्यात्मिक और ग्रहीय संतुलन के लिए पवित्र माला",
        lifeRudraksha: "जीवन रुद्राक्ष",
        fortuneRudraksha: "भाग्य रुद्राक्ष",
        rudrakshNote: "रुद्राक्ष को ठीक से ऊर्जावान किया जाना चाहिए और किसी योग्य ज्योतिषी से परामर्श के बाद पहना जाना चाहिए। नियमित ध्यान और मंत्र जाप उनके आध्यात्मिक लाभ को बढ़ाते हैं।",

        // Overview Tab
        birthDetails: "जन्म विवरण",
        birthDetailsDesc: "आपके जन्म समय, तिथि और स्थान के बारे में आवश्यक जानकारी।",
        name: "नाम",
        gender: "लिंग",
        dateOfBirth: "जन्म की तारीख",
        timeOfBirth: "जन्म का समय",
        lagnaAsc: "लग्न (Asc)",
        moonSign: "चंद्र राशि",
        location: "स्थान",
        avakhadaChakra: "अष्टकूट चक्र",
        avakhadaDesc: "अनुकूलता के लिए चंद्र राशि की विशेषताएं और ज्योतिषीय विशेषताएँ।",
        rashi: "राशि",
        rashiLord: "राशि स्वामी",
        varna: "वर्ण",
        vashya: "वश्य",
        yoni: "योनि",
        gana: "गण",
        nadi: "नाड़ी",
        tatva: "तत्व",
        alphabet: "वर्ण",
        paya: "पाया",
        birthPanchang: "जन्म पंचांग",
        panchangDesc: "आपके जन्म के समय शुभ तत्व और ब्रह्मांडीय ऊर्जाएं।",
        vaara: "वार (दिन)",
        tithi: "तिथि",
        nakshatra: "नक्षत्र",
        yoga: "योग",
        karana: "करण",
        chartSuffix: "चार्ट",
        chartDesc: "ग्रहीय स्थितियों का दृश्य प्रतिनिधित्व।",

        // Planets Tab
        planetaryPositions: "ग्रहीय स्थितियां",
        planetsDesc: "आपके जन्म के समय ग्रहों की विस्तृत कोणीय स्थिति और गरिमा।",
        planet: "ग्रह",
        sign: "राशि",
        degree: "डिग्री",
        house: "भाव",
        pada: "पद",
        dignity: "गरिमा",
        nature: "प्रकृति",
        ascendant: "लग्न",
        malefic: "पाप ग्रह",
        benefic: "शुभ ग्रह",

        // Dasha Tab
        vimshottariDasha: "विंशोत्तरी दशा",
        dashaDesc: "ग्रहीय समयावधियां जो आपके जीवन के विभिन्न चरणों को प्रभावित करती हैं।",
        backTo: "वापस",
        mahadasha: "महादशा",
        antardasha: "अंतर्दशा",
        pratyantardasha: "प्रत्यंतरदशा",
        currPeriod: "वर्तमान अवधि",
        starts: "शुरू",
        ends: "समाप्त",
        duration: "अवधि",
        years: "वर्ष",

        // Dosha Tab
        manglikDosha: "मांगलिक दोष",
        manglikDesc: "वैवाहिक सुख और संबंधों को प्रभावित करने वाली मंगल की स्थिति।",
        present: "उपस्थित",
        absent: "अनुपस्थित",
        severity: "तीव्रता",
        kalsarpaAnalysis: "कालसर्प विश्लेषण",
        kalsarpaDesc: "जीवन की चुनौतियों और आध्यात्मिक विकास पर राहु-केतु अक्ष का प्रभाव।",
        type: "प्रकार",
        noKalsarpa: "कोई कालसर्प दोष नहीं",
        sadesatiAnalysis: "शनि साढ़े साती विश्लेषण",
        sadesatiDesc: "शनि की साढ़े सात साल की गोचर अवधि और उसके प्रभाव।",
        inSadesati: "वर्तमान में साढ़े साती अवधि में",
        notInSadesati: "साढ़े साती अवधि में नहीं",
        currentlyActive: "वर्तमान में सक्रिय",
        currentPhase: "वर्तमान चरण",
        nextStartsOn: "अगला प्रारंभ",
        severityLevel: "तीव्रता स्तर",
        timelineSadesati: "साढ़े साती अवधियों की समयरेखा",
        startDate: "आरंभ तिथि",
        endDate: "समाप्ति तिथि",
        saturnSign: "शनि राशि",
        saturnIn: "शनि",
        phase: "चरण",
        status: "स्थिति",
        active: "सक्रिय",
        upcoming: "आगामी",
        completed: "पूर्ण",
        yes: "हाँ",
        no: "नहीं",
        none: "कोई नहीं",

        // Predictions Tab
        predictionsGenerating: "विस्तृत भविष्यवाणियां उत्पन्न की जा रही हैं। कृपया प्रतीक्षा करें या पुनः कुंडली बनाने का प्रयास करें।",
        faladeshTitle: "फलादेश - जीवन भविष्यवाणियां",
        faladeshDesc: "आपके लग्न राशि पर आधारित व्यापक जीवन अंतर्दृष्टि।",
        generalDesc: "सामान्य विवरण",
        personalityTraits: "व्यक्तित्व लक्षण",
        physicalAppearance: "शारीरिक बनावट",
        healthInsights: "स्वास्थ्य अंतर्दृष्टि",
        careerProspects: "करियर संभावनाएं",
        relationships: "संबंध",
        planetEffectsTitle: "D1 चार्ट में ग्रहीय प्रभाव",
        planetEffectsDesc: "आपकी जन्म कुंडली में अपनी स्थिति के आधार पर प्रत्येक ग्रह आपके जीवन को कैसे प्रभावित करता है।",
        mahaDashaTitle: "महादशा भविष्यवाणियां",
        mahaDashaDesc: "आपके जीवन के प्रत्येक प्रमुख ग्रहीय काल के लिए विस्तृत पूर्वानुमान।",

        // Hero Section
        freeKundliOnline: "ऑनलाइन कुंडली",
        freeKundliDesc: "त्वरित और सटीक जन्म कुंडली प्राप्त करें। व्यक्तिगत ग्रह स्थितियों और गहरी ज्योतिषीय अंतर्दृष्टि को अनलॉक करने के लिए अपना जन्म विवरण दर्ज करें।",

        // Kundli Form
        enterDetails: "विवरण दर्ज करें",
        createYour: "अपनी",
        kundliTitle: "कुंडली बनाएं",
        enterBirthDetails: "अपनी विस्तृत जन्म कुंडली बनाने के लिए अपना जन्म विवरण दर्ज करें।",
        fullName: "पूरा नाम",
        fullNamePlaceholder: "पूरा नाम दर्ज करें",
        birthLocation: "जन्म स्थान",
        placeOfBirth: "जन्म स्थान",
        searchCity: "शहर खोजें",
        male: "पुरुष",
        female: "महिला",
        other: "अन्य",
        generating: "उत्पन्न हो रहा है...",
        readingStars: "सितारों को पढ़ा जा रहा है...",
        generateKundli: "कुंडली बनाएं",
        generateFreeKundli: "निःशुल्क कुंडली बनाएं",
        reset: "रीसेट",
        clearForm: "फ़ॉर्म साफ़ करें",

        // Saved Kundli List
        savedCharts: "सहेजे गए चार्ट",
        searchCharts: "चार्ट खोजें...",
        loading: "लोड हो रहा है...",
        noSavedKundlisYet: "अभी तक कोई सहेजी गई कुंडली नहीं",
        cloudSaved: "क्लाउड सेव्ड",
        deleteFromCloud: "क्लाउड से हटाएं",
        savedLocally: "स्थानीय रूप से सहेजा गया",
        saveToCloud: "क्लाउड में सहेजें",
        removeLocal: "स्थानीय हटाएं",
        login: "लॉगिन",
        toSyncKundlis: "अपनी कुंडली को क्लाउड पर सिंक करने और कहीं से भी एक्सेस करने के लिए।",
        kundliRemoved: "कुंडली हटा दी गई",
        kundliDeletedCloud: "क्लाउड से कुंडली हटा दी गई",
        loginToSave: "क्लाउड पर सहेजने के लिए कृपया लॉगिन करें",
        kundliSavedCloud: "कुंडली क्लाउड पर सहेजी गई!",
        viewChart: "चार्ट देखें",
        delete: "हटाएं",
        openKundli: "कुंडली खोलें",
        noChartsFound: "इसके लिए कोई चार्ट नहीं मिला",

        // PDF Download
        downloadPdf: "PDF डाउनलोड करें",
        viewAndPrint: "देखें और प्रिंट करें",
        downloadKundli: "अपनी कुंडली डाउनलोड करें",
        downloadKundliDesc: "अपनी जन्म कुंडली का पूर्ण विश्लेषण PDF में प्राप्त करें",
        language: "भाषा",
        kundliReport: "कुंडली रिपोर्ट",
        generatedBy: "BhriguGPT द्वारा निर्मित",
        generatedOn: "निर्माण तिथि",
        pdfDownloading: "PDF तैयार हो रहा है...",
        pdfReady: "PDF डाउनलोड के लिए तैयार!",
        pdfError: "PDF उत्पन्न करने में विफल"
    }
};
